exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2QhqEJG0DLiSa9oNo_L8GO{outline:none}html[dir] ._2QhqEJG0DLiSa9oNo_L8GO{border-radius:4px}", ""]);
// Exports
exports.locals = {
	"dialog": "_2QhqEJG0DLiSa9oNo_L8GO"
};